const invalidFeedback = ".invalid-feedback";
const invalidClass = "is-invalid";
const focusField = require("./focusField");

/**
  * @description Scroll to an element
  * @param {Object} el - The element to scroll to
  * @param {string} speed - Scroll speed
  */
const scrollToElement = (el, speed) => {
    $("html, body").animate({
        "scrollTop": $(el).offset().top
    }, speed);
};

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
const loadFormErrs = (parentSelector, fieldErrors, scrollableElement) => { // eslint-disable-line
    let $field;
    fieldErrors = fieldErrors.fields || fieldErrors;
    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, attr => {
        const $select = $("select[name=" + attr + "]", parentSelector);
        if ($select.length === 0) {
            $field = $("*[name=" + attr + "]", parentSelector);
        } else {
            $field = $select.closest(".form-control");
        }

        if ($field.siblings(invalidFeedback).length === 0) {
            $field
                .addClass(invalidClass)
                .parents(".form-group")
                .find(invalidFeedback)
                .html(fieldErrors[attr]);
        } else {
            $field
                .addClass(invalidClass)
                .siblings(invalidFeedback)
                .html(fieldErrors[attr]);
        }

        $(window).trigger("loadedFormErrors");
    });

    $(".header-content").addClass("js-remove-sticky");

    var $focusableElement = $(parentSelector).closest(".modal:visible").length ?
        $("." + invalidClass, parentSelector).first() :
        $("." + invalidClass).first();

    focusField($focusableElement, scrollableElement);
};

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
const clearPrevErrors = (parentSelector) => {
    const $parent = $(parentSelector);
    $parent.find(".form-control.is-invalid").removeClass(invalidClass);
    $parent.find(".form-group.is-invalid").removeClass(invalidClass);
    $(".error-message").hide();
};

export const loadFormErrors = loadFormErrs;
export const clearPreviousErrors = clearPrevErrors;
export const scrollToEl = scrollToElement;
